export const FAN_TAKEOVER_FLOOR_SIZES: {
  [key in
    | "DESKTOP_COLLAPSE"
    | "DESKTOP_SUCCESS"
    | "MOBILE_COLLAPSE"
    | "MOBILE_SUCCESS"]: [number, number];
} = {
  DESKTOP_COLLAPSE: [9, 9],
  DESKTOP_SUCCESS: [11, 11],
  MOBILE_COLLAPSE: [6, 6],
  MOBILE_SUCCESS: [8, 8],
};
